import { atom } from 'nanostores';

// Store to track the threshold for eager loading (first N components)
export const $eagerLoadingThreshold = atom<number>(3);

// Store to track current component index
export const $currentComponentIndex = atom<number>(0);

// Helper function to check if current component should load eagerly
export const shouldLoadEagerly = (): boolean => {
  const threshold = $eagerLoadingThreshold.get();
  const currentIndex = $currentComponentIndex.get();
  return currentIndex < threshold;
};

// Helper function to increment component index (called by ComponentLoop)
export const incrementComponentIndex = (): number => {
  const currentIndex = $currentComponentIndex.get();
  const newIndex = currentIndex + 1;
  $currentComponentIndex.set(newIndex);
  return newIndex;
};

// Helper function to reset component index (called at start of ComponentLoop)
export const resetComponentIndex = (): void => {
  $currentComponentIndex.set(0);
};

// Helper function to set threshold (called by ComponentLoop)
export const setEagerLoadingThreshold = (threshold: number): void => {
  $eagerLoadingThreshold.set(threshold);
};
